<template>
  <v-dialog v-model="open" :persistent="true" max-width="640" scrollable>
    <v-card>
      <v-card-title class="text-h5">{{ popup.title }}</v-card-title>
      <v-card-subtitle>{{ popup.kicker }}</v-card-subtitle>
      <v-card-text>
        <p>{{ popup.intro }}</p>

        <p class="text-subtitle-1 mt-4">{{ popup.channels_title }}</p>
        <ul>
          <li v-for="ch in popup.channels || []" :key="ch.key">
            <strong>{{ ch.title }}</strong> — {{ ch.text }}
          </li>
        </ul>

        <p class="text-subtitle-1 mt-4">{{ popup.purposes_title }}</p>
        <ul>
          <li v-for="(purpose, idx) in popup.purposes || []" :key="idx">{{ purpose }}</li>
        </ul>

        <p class="text-subtitle-1 mt-4">{{ popup.no_share_title }}</p>
        <p>{{ popup.no_share }}</p>

        <p class="text-subtitle-1 mt-4">{{ popup.rights_title }}</p>
        <p>{{ popup.rights }}</p>
        <p class="text-caption">{{ popup.footnote }}</p>

        <v-checkbox
          v-model="acceptedCheck"
          :label="popup.checkbox"
          hide-details
        ></v-checkbox>

        <p class="mt-2">
          <span class="fakeLink" @click="togglePolicy">{{ popup.read_policy }}</span>
        </p>
        <pre
          v-if="showPolicy"
          class="text-body-2"
          style="white-space:pre-wrap"
        >{{ policy }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-btn variant="text" @click="leave">{{ popup.leave_label || 'Sair' }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="text"
          :disabled="!acceptedCheck || saving"
          @click="accept"
        >{{ popup.accept_label || 'Concordo e continuar' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import api from '@/services'

const DEFAULT_CHANNELS = { email: true, whatsapp: true, push: true }

export default {
  name: 'DialogLgpd',
  setup() {
    return { api }
  },
  data() {
    return {
      open: false,
      saving: false,
      acceptedCheck: false,
      showPolicy: false,
      popup: {},
      policy: '',
      channels: { ...DEFAULT_CHANNELS },
    }
  },
  created() {
    this.checkStatus()
  },
  activated() {
    this.checkStatus()
  },
  mounted() {
    window.__GGRUPOS_LGPD_VUE = true
  },
  methods: {
    shouldSkip() {
      return !api.auth.isLoggedIn()
        || this.$route?.name === 'Auth'
        || api.lgpd.isPublicPath(this.$route?.path)
    },
    applyStatus(status) {
      if (!status?.needs_accept) {
        this.open = false
        return
      }
      this.acceptedCheck = false
      this.showPolicy = false
      this.saving = false
      this.open = true
      if (status.popup) this.popup = status.popup
      if (status.policy) this.policy = status.policy
      if (status.channels) {
        this.channels = { ...DEFAULT_CHANNELS, ...status.channels }
      }
    },
    checkStatus() {
      if (this.shouldSkip()) {
        this.open = false
        return
      }
      return api.lgpd.status()
        .then((status) => {
          this.applyStatus(status)
        })
        .catch((err) => {
          console.warn(err)
          this.open = false
        })
    },
    togglePolicy() {
      this.showPolicy = !this.showPolicy
      if (this.showPolicy && !this.policy) {
        api.lgpd.policy()
          .then((payload) => {
            if (payload?.policy) this.policy = payload.policy
            if (payload?.popup && !this.popup?.title) this.popup = payload.popup
          })
          .catch((err) => {
            console.warn(err)
          })
      }
    },
    leave() {
      api.auth.logoutAndRedirect()
    },
    accept() {
      if (!this.acceptedCheck || this.saving) return
      this.saving = true
      return api.lgpd.accept({ accepted: true, channels: this.channels })
        .then(() => {
          this.open = false
        })
        .catch((err) => {
          console.warn(err)
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
  computed: {
    loggedIn() {
      return api.auth.isLoggedIn()
    },
  },
  watch: {
    '$route.fullPath'() {
      this.checkStatus()
    },
    loggedIn() {
      this.checkStatus()
    },
  },
}
</script>
